<template>
  <div class="drop-modal">
    <div class="swiper-container" ref="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,key) in moduleData.bg_img_list" :key="key">
          <img :src="item.img_url" alt>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="button-img" @click="toggleModal">
      <img :src="moduleData.form_img_url" alt>
    </div>
    <div class="modal-wraper" ref="mobileModal">
      <div class="form-item">
        <input type="text" v-model="phone" maxlength="11" placeholder="请输入手机号">
      </div>
      <div class="form-item">
        <input type="text" v-model="phoneCode" placeholder="请输入验证码" class="short-input">
        <div class="phone-code-btn" @click="getPhoneCode">{{getPh.text}}</div>
      </div>

      <p class="notice" v-if="notice1">{{notice1}}</p>
      <div class="submit-btn" @click="submit">点击提交</div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import util from "../../assets/js/util";
import encrypt from '../../api/encrypt';
import {traceLog} from '../../api/api';
let note = {};
let regPhone = /^1[3456789]\d{9}$/;
let regPhoneCode = /\d{6}/;
function getQueryStringAll(params) {
  var str = location.search.substring(1).split('&');

  for (var i = 0; i < str.length; i++) {
    var val = str[i].split('=');
    if (!val[0]) break;
    params.note[val[0]] = val[1];
  }

  // params.partyId = params.note['partyId'] || '';
  params.note = JSON.stringify(params.note);

  return params;
}
function reducerData(params, note) {
  var result = JSON.parse(JSON.stringify(note));
  console.log(result)
  for (var item in params) {
    console.log(item)
    if (item == 'note') break;
    result[item] = params[item];
  }
  result['activeId'] = 'BAIDU_UP';

  return result;
}
export default {
  props: {
    moduleData: {
      type: Object
    },
    pageName: {
      type: String
    }
  },
  data() {
    return {
      showModal: false,
      toggleFlag: false,
      phone: "",
      phoneCode: "",
      getPh: {
        text: "发送验证码",
        boolean: false
      },
      type: "209",
      notice1: ""
    };
  },
  mounted() {
    new Swiper(".swiper-container", {
      direction: "horizontal", // 垂直切换选项
      loop: true, // 循环模式选项
      autoplay: true,
      pagination: {
        el: ".swiper-pagination"
      }
    });
  },
  methods: {
    toggleModal() {
      if (this.toggleFlag) return;
      this.showModal = !this.showModal;
      this.toggleFlag = true;
      let el = this.$refs.mobileModal;
      if (!this.showModal) {
        el.style.top = 0;
        setTimeout(() => {
          el.style.opacity = 0;
          this.toggleFlag = false;
        }, 300);
      } else {
        el.style.opacity = 1;
        el.style.top = "100%";
        this.toggleFlag = false;
      }
    },
    getPhoneCode() {
      if (this.getPh.boolean) return;
      util.ui.createWait();
      if (this.phone == "") {
        this.notice1 = "请输入您的手机号";
        util.ui.closeWait();
        return false;
      } else {
        if (!regPhone.test(this.phone)) {
          this.notice1 = "请输入11位手机号";
          util.ui.closeWait();
          return false;
        } else {
          this.notice1 = "";
          util
            .ajax({
              reqData: [
                {
                  method: "common.send_phone_code",
                  params: {
                    phone: this.phone,
                    method: "1",
                    type: this.type
                    // "imgcode": this.imgCodeUrl
                  }
                }
              ]
            })
            .then((err, res) => {
              util.ui.closeWait();
              console.log(res);
              let second = 59;
              let inter = undefined;
              if (err || res.error) {
                if (
                  [11105, 16001, 16002, 16006].indexOf(res.error.code) != -1
                ) {
                  this.imgCodeUrl = util.getCaptchaUrl(150, 50);
                }
              }
              this.getPh.text = second + "秒后重发";
              this.getPh.boolean = true;
              inter = setInterval(() => {
                if (second == 0) {
                  this.getPh.text = "重新发送";
                  this.phoneCode = "";
                  clearInterval(inter);
                  this.getPh.boolean = false;
                } else {
                  second = second - 1;
                  this.$set(this.getPh, "text", second + "秒后重发");
                }
              }, 1000);
            });
        }
      }
    },
    verifyPhone() {
      if (this.phone == '') {
        this.notice1 = '请输入您的手机号';
        return false;
      } else if (!regPhone.test(this.phone)) {
        this.notice1 = '请输入正确的手机号';
        return false;
      } else {
        this.notice1 = '';
        return true;
      }
    },
    verifyPhoneCode() {
      if (this.phoneCode == '') {
        this.notice1 = '请输入短信验证码';
        return false;
      } else if (!regPhoneCode.test(this.phoneCode)) {
        this.notice1 = '请输入正确的短信验证码';
        return false;
      } else {
        this.notice1 = '';
        return true;
      }
    },
    //投资者资格认证提交
    submit () {
      // window._agl && window._agl.push(['track', ['success', {t: 3}]])
      this.notice1 = '';

      if(!this.verifyPhone()|| !this.verifyPhoneCode()) {
        return;
      }

      var preParams = {
        mobilePhone: this.phone,
        name: this.name || '匿名',
        phoneCode: this.phoneCode,
        note: {'partyId': this.partyId},
        partyId: this.partyId
      };

      var params = getQueryStringAll(preParams);
      console.log(params)
      var activeData = reducerData(params, {"partyId": this.partyId});

      util.ajax({
        reqData: [{
          "method": "active.baidu_potential_customer",
          "params": params
        }]
      }).then((err, resArr) => {
        console.log(resArr)
        let bindParams = {
          "mobilePhone": this.phone
        }
        let sid = resArr[0].result;
        localStorage.setItem('sid', sid);
        console.log(bindParams)
        if (resArr[1].result && resArr[1].result.code == '0') {
          util.ajax({
            header: {"X-KGW-SID": sid},
            reqData: [{
              "method": "active.customer_is_bind_fa",
              "params": bindParams
            }]
          }).then((err, resArr) => {
            console.log(resArr)
            console.log(resArr[1].result && resArr[1].result.isBindFa)
            this.$emit('setHasFa', !!resArr[1].result && resArr[1].result.isBindFa=='1') //isBindFa 1 有绑定的理财师
            // this.hasFa = !!resArr[1].result && resArr[1].result.isBindFa
            this.nextStep(1)

            let pubKey = '-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKwXxvLaOA1f/dVRQgS76HRrgRh8N7jqYScrSciQYtNtJ5hpCHmSHdjHXe4IK9lOT5SJHhZLXg/c2tFhvicoxAsCAwEAAQ==-----END PUBLIC KEY-----';
            let phone = encrypt(pubKey, this.phone);
            console.log(phone)
            traceLog({
              page_name: this.pageName, // 默认 为 0
              user_name: this.name || '匿名',
              phone: phone,
              from_url: encodeURI(location.href), // 需要url编码
            }).then((resLog) => {
              let reserveId = resLog.data.reserveId;
              localStorage.setItem('reserveId',reserveId);
            })
          })
        } else {
          this.notice3 = resArr[1].error.message
        }
      })
    },
    //身份证认证 注册微诺亚会员
    nextStep (step) {
      this.$emit('setStep', step + 1);
    },
  }
};
</script>
<style lang="less" scoped>
.drop-modal {
  position: relative;
  width: 100%;
  height: 4.2rem;
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide img {
      width: 100%;
    }
  }
  .button-img {
    position: absolute;
    top: 0;
    right: 4.8rem;
    width: 2.6rem;
    height: 100%;
    z-index: 11;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .modal-wraper {
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    right: 4.8rem;
    width: 2.6rem;
    left: auto;
    z-index: 10;
    transition: 0.3s linear top;
    opacity: 0;
    top: 0;
    transform: none;
    padding: 0 16px;
    box-sizing: border-box;
    padding-bottom: 0.37rem;
    .form-item {
      height: auto;
      padding-top: 0.33rem;
      border-bottom: 1px solid #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 0.1rem;
      .phone-code-btn {
        border-radius: 5px;
        border: 1px solid #fff;
        color: #fff;
        font-size: 12px;
        height: 0.3rem;
        line-height: 0.3rem;
        padding: 0 5px;
        white-space: nowrap;
      }
    }
    input {
      width: 100%;
      background-color: transparent;
      border: 0;
      height: 0.3rem;
      line-height: 0.3rem;
      color: #fff;
    }
    input:focus {
      outline: 0;
    }
    input::-webkit-input-placeholder {
      color: #fff;
    }
    input::-moz-input-placeholder {
      color: #fff;
    }
    input::-ms-input-placeholder {
      color: #fff;
    }
    .submit-btn {
      height: 0.4rem;
      background: linear-gradient(to bottom right, #ddaa73, #f1cfaa);
      border-radius: 5px;
      margin-top: 0.22rem;
      color: #000;
      font-size: .22rem;
      text-align: center;
      line-height: 0.4rem;
      font-weight: 700;
      cursor: pointer;
    }
    .notice {
      font-size: 12px;
      line-height: 0.3rem;
      color: red;
      text-align: left;
      margin-top: 5px;
    }
  }

  .swiper-container {
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/content-drop.vue